import { useTicketModalStore } from "@/store/erp/ticket-soporte/useTicketModalStore"
import { ScrollableDialogProps } from "../../ui/Dialogs"
import { Box, Chip, IconButton, Paper, Tooltip, Typography } from "@mui/material"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IoCreate } from "react-icons/io5";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from "react-router-dom"
import { ROUTER_PATHS } from "@/shared/constants"
import type { IClienteBusqueda } from "@/shared/interfaces/erp/tickets-soporte-clientes/gestion-ticket.interface";


export type DatosSoporteClienteProps = {
  data: IClienteBusqueda[];
}
export default function TableTicketSearchByEnter({ data }: DatosSoporteClienteProps) {
  const navigate = useNavigate()
  const isOpenModalSearchEnter = useTicketModalStore(s => s.isModalSearchEnterOpen)
  const setIsModalSearchEnterOpen = useTicketModalStore(s => s.setIsModalSearchEnterOpen)

  const handleCrearTicket = (cliente: IClienteBusqueda) => {
    setIsModalSearchEnterOpen(false)
    navigate(
      `${ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav}?clienteId=${cliente.id}&contratoId=${cliente.contrato_id || ''}&crearTicket=true`
    )
  }

  const handleVerPerfil = (cliente: IClienteBusqueda) => {
    setIsModalSearchEnterOpen(false)
    navigate(
      `${ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav}?clienteId=${cliente.id}&contratoId=${cliente.contrato_id || ''}`
    )
  }

  return (
    <ScrollableDialogProps
      open={isOpenModalSearchEnter}
      onCloseIcon={() => setIsModalSearchEnterOpen(false)}
      onClose={() => setIsModalSearchEnterOpen(false)}
      title="Resultados de búsqueda"
      minWidth="60%"
      contentNode={
        <Box>
          {data.length > 0 && (
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
              {data.length} resultado{data.length !== 1 ? 's' : ''} encontrado{data.length !== 1 ? 's' : ''}
            </Typography>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxHeight: 500, overflowY: 'auto' }}>
            {data.map((cliente, idx) => (
              <Paper
                key={`${cliente.id}-${cliente.contrato_id}-${idx}`}
                elevation={1}
                sx={{
                  p: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Typography variant="body2" fontWeight="bold">
                      {cliente.contrato_codigo ? `Contrato ${cliente.contrato_codigo}` : cliente.nombre_completo}
                    </Typography>
                    {cliente.tiene_masivo_activo && (
                      (cliente as any).masivo_estado === 'pausado'
                        ? <Chip label="ALERTA" size="small" color="warning" />
                        : <Chip label="MASIVO" size="small" color="error" />
                    )}
                    {cliente.estado && (
                      <Chip
                        label={cliente.estado}
                        size="small"
                        variant="outlined"
                        color={cliente.estado === 'ACTIVO' ? 'success' : 'default'}
                      />
                    )}
                    {cliente.plan && (
                      <Chip label={cliente.plan} size="small" variant="outlined" />
                    )}
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    {cliente.nombre_completo} — {cliente.cedula}
                  </Typography>
                  {cliente.direccion && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                      <LocationOnIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                      <Typography variant="body2" fontWeight="bold">
                        {cliente.direccion}
                      </Typography>
                    </Box>
                  )}
                  {(cliente.ip || cliente.serie_ont) && (
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.25 }}>
                      {cliente.ip ? `IP: ${cliente.ip}` : ''}
                      {cliente.ip && cliente.serie_ont ? ' | ' : ''}
                      {cliente.serie_ont ? `ONT: ${cliente.serie_ont}` : ''}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Crear Ticket">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => handleCrearTicket(cliente)}
                    >
                      <IoCreate />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Ver Perfil 360">
                    <IconButton
                      size="small"
                      color="info"
                      onClick={() => handleVerPerfil(cliente)}
                    >
                      <RemoveRedEyeIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Paper>
            ))}
          </Box>

          {data.length === 0 && (
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography color="text.secondary">
                No se encontraron resultados
              </Typography>
            </Paper>
          )}
        </Box>
      }
    />
  )
}
